import { createApp } from "vue";

import { initializeFirebase } from "@/infrastructure/firebase";
import { initSentry } from "@/utilities/sentry";

import store, { key } from "@/store/store";
import { router } from "@/router";

// import "bootstrap/dist/css/bootstrap.min.css";
import "./css/custom.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

import App from "./App.vue";

initializeFirebase();

const app = createApp(App);

import pkg from "../package.json";

const version = pkg.version;

initSentry(app, {
  dsn: "https://41493b33347f42e09b10f7b4e11ddb54@o1130341.ingest.sentry.io/6174326",
  tracesSampleRate: 1.0,
  release: `yomumo@${version}-${process.env.VITE_GIT_COMMIT_HASH}`,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: ["Load failed"],
  beforeSend(event: { type?: string }, hint: { originalException?: unknown }) {
    const error = hint.originalException;
    if (
      error &&
      typeof error === "object" &&
      "message" in error &&
      error.message ===
        "Failed to get document because the client is offline."
    ) {
      return null;
    }
    return event;
  },
});

store.dispatch("startAuth");

app.use(router).use(store, key).mount("#app");
